import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
    drawer_container: {
        flexShrink: 0,
        "& .MuiDrawer-paper": {
            width: 420,
            height: "calc(100vh -100px)",
            overflow: "visible",
            border: "none",
            marginTop: "75px",
            boxShadow: "0 0 10px 0 rgba(0,0,0,0.15)",
            ...(theme.direction !== "rtl" ? { borderRadius: "16px 0 0 16px" } : { borderRadius: "0 16px 16px 0" }),
        },
    },

    editMode_drawer_container: {
        flexShrink: 0,
        "& .MuiDrawer-paper": {
            width: 420,
            height: "calc(100vh -100px)",
            overflow: "visible",
            border: "none",
            marginTop: "160px",
            boxShadow: "0 0 10px 0 rgba(0,0,0,0.15)",
            ...(theme.direction !== "rtl" ? { borderRadius: "16px 0 0 16px" } : { borderRadius: "0 16px 16px 0" }),
        },
    },

    scrollable_content_container: {
        height: "calc(100vh - 100px)",
        width: "100%",
    },

    main_drawer_container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        flexDirection: "column",
        position: "relative",
        padding: "14px 0px",
        paddingInlineStart: 32,
        overflowY: "hidden",
    },

    title_text: {
        fontWeight: "bold",
        fontSize: "20px",
        letterSpacing: 0,
        lineHeight: "24px",
    },

    main_drawer_icon: {
        position: "absolute",
        top: 20,
        ...(theme.direction !== "rtl" ? { right: 25 } : { left: 25 }),
    },

    main_drawer_ourProducts: {},

    productsList: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        width: "100%",
        height: "100%",
    },

    see_more: {
        textDecoration: "underline",
        fontWeight: "bold",
        letterSpacing: 0,
        fontSize: "16px",
        cursor: "pointer",
    },

    small_drawer_container_sx: {
        flexShrink: 0,
        "& .MuiDrawer-paper": {
            width: 91,
            height: 90,
            border: "none",
            marginTop: "75px",
            ...(theme.direction !== "rtl" ? { borderRadius: "4px 0 0 4px" } : { borderRadius: "0 4px 4px 0" }),
        },
    },

    editMode_small_drawer_container_sx: {
        flexShrink: 0,
        "& .MuiDrawer-paper": {
            width: 91,
            height: 90,
            border: "none",
            marginTop: "160px",
            ...(theme.direction !== "rtl" ? { borderRadius: "4px 0 0 4px" } : { borderRadius: "0 4px 4px 0" }),
        },
    },

    small_drawer_container: {
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        backgroundColor: "#F5F7FB",
        borderRadius: "4px",
        overflow: "hidden",
    },

    small_drawer_title_container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        flexDirection: "column",
        padding: "0px 15px",
        letterSpacing: 0,
        fontSize: "14px",
        lineHeight: "17px",
    },

    header: {
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        height: 50,
    },

    contentContainer: {
        height: "calc(100vh - 190px)",
        overflowY: "auto",
    },

    drawersWrapper_container: {},
    mainDrawer_wrapper: {},
    smallDrawer_wrapper: {
        zIndex: 100000,
        position: "absolute",
    },
}));

export default useStyles;
